import { GridCellParams } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';
import { Link } from 'react-router-dom';
import { GridCustomColDef } from '../../../types';
import { DetailCTARenderer } from '../../UpstackDataGrid/CellRenderers/DetailCTARenderer';
import { ComponentName, getMetaData } from '../../DetailsDrawer/detailsDrawersHelpers';
import { advancedNumericOperators, advancedOperators } from '../../UpstackDataGrid/helpers';

export const BulkArchiveRPMGridColumnDefs: GridCustomColDef[] = [
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'details',
    headerName: '',
    sortable: false,
    width: 65,
    filterable: false,
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
        state={{
          id: v4(),
          data: params.row,
          ...getMetaData({ name: ComponentName.RPM_ACCOUNT, id: params.row.accountId }),
          replace: true
        }}
      />
    ),
    hideable: false,
    pinned: 'left',
    disableReorder: true
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'accountId',
    headerName: 'RPM Account ID',
    sortable: true,
    filterable: true,
    flex: 1,
    minWidth: 170,
    description: 'Drag to move column',
    filterOperators: advancedNumericOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'accountNumber',
    headerName: 'RPM Account Number',
    renderCell: (params: GridCellParams) => (
      <Link
        className="text-indigo"
        title="Fullscreen"
        to={`/rpm-account/${params.row.accountId}`}>
        <div className="flex items-center text-small">{(params.value as string) ?? ''}</div>
      </Link>
    ),
    sortable: true,
    filterable: true,
    flex: 1,
    minWidth: 200,
    description: 'Drag to move column',
    filterOperators: advancedOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'supplier',
    headerName: 'RPM Supplier',
    sortable: true,
    filterable: true,
    flex: 1,
    minWidth: 170,
    description: 'Drag to move column',
    filterOperators: advancedOperators()
  }
];
